import { Action } from '@ngrx/store';

export class DigitalSubscriptionAction implements Action {

    public static getPurchase = '[Digital Subscription] get_purchase';
    public static getPurchaseError = '[Digital Subscription] get_purchase_error';
    public static getPurchaseSuccess = '[Digital Subscription] get_purchase_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
